import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../grid/grid';
import '../typography/typography';
import classnames from 'classnames';
import css from './slim-button.css';

const SlimButton = ({
  children,
  type,
  className,
  icon,
  secondary,
  inverse,
  disabled,
  ...otherProps
}) => (
  <button
    className={classnames(
      css['ds-slim-button'],
      {
        [css['ds-slim-button--secondary']]: secondary,
        [css['ds-slim-button--inverse']]: inverse,
        [css['ds-slim-button--icon']]: icon,
      },
      className,
    )}
    // eslint-disable-next-line react/button-has-type
    type={type}
    disabled={disabled}
    {...otherProps}
  >
    {children}
  </button>
);

SlimButton.defaultProps = {
  type: 'button',
  className: '',
  icon: false,
  secondary: false,
  inverse: false,
  disabled: false,
};

SlimButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  className: PropTypes.string,
  icon: PropTypes.bool,
  secondary: PropTypes.bool,
  inverse: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SlimButton;
